<template>
  <ul class="nav nav-tabs nav-fill">
    <li>
      <router-link
        :to="{ name: 'pipelines' }"
        class="nav-link text-dark"
        :class="{ active: activeRoute === 'pipelines' }"
      >
        Конвейеры
      </router-link>
    </li>
    <li>
      <router-link
        :to="{ name: 'ci-jobs' }"
        class="nav-link text-dark"
        :class="{ active: activeRoute === 'ci-jobs' }"
      >
        Задачи
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'CiCdTabs',
  computed: {
    activeRoute() {
      return this.$route.name;
    }
  }
};
</script>
